const local = {

    en:{
    model:"Select the model",
    submit:"ADD",
    date:"Purchase date:",
    dateofby:"Purchase date",
    serialn:"Serial number",
    warn:"Please note: You can change the serial number within 24 hours of registration.",
    empty:"Instrument type",
    dalnomer:"Laser distancemeters",
    lazlevel:"Line levels",
    newadd_ttl:"+New instrument",
    },

    ru:{
    model:"Выберите модель",
    submit:"ДОБАВИТЬ",
    date:"Дата покупки:",
    dateofby:"Дата покупки",
    serialn:"Серийный номер",
    warn:"Внимание! Вы сможете изменить серийный номер в течение суток после регистрации.",
    empty:"Тип прибора",
    dalnomer:"Лазерные дальномеры",
    lazlevel:"Линейные нивелиры",
    newadd_ttl:"+ Новый прибор",
    },

    de:{
    model:"Modell auswählen",
    submit:"Hinzufügen",
    date:"Kaufdatum:",
    dateofby:"Kaufdatum",
    serialn:"Seriennummer",
    warn:"Achtung! Sie können die Seriennummer innerhalb von 24 Stunden nach der Registrierung ändern.",
    empty:"Gerätetyp",
    dalnomer:"Laser-Entfernungsmesser",
    lazlevel:"Laserliniennivellierer ",
    newadd_ttl:"+ Neues Gerät",
    },

};

export default local;